import RegisterAuth from './register-auth'
import RegisterBase1 from './register-base1'
import RegisterBase2 from './register-base2'
import RegisterAboutMe from './register-about-me'
import RegisterAboutPartner from './register-about-partner'
import RegisterInterests from './register-interests'
import RegisterFinal from './register-final'

export default {
    states: Vue.observable({
        is_closing: false,
        is_open: false,
        visible: false,
        loading: false,
        ages: [18, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 80],
        interests: [],
        steps: [
            RegisterAuth,
            RegisterBase1,
            RegisterBase2,
            RegisterAboutMe,
            RegisterAboutPartner,
            RegisterInterests,
            RegisterFinal,
        ],
        current_step: 1,
        isSocialRegister: false,
        form: {
            username: '',
            password: '',
            i_am: "man",
            looking_for: "woman",
            start_age: 18,
            end_age: 70,
            countries: [],
            place: null,
            avatar: null,
            dob: null,
            about_me: '',
            about_partner: '',
            interests: [],
            rules: false,
            dataRules: false,
            emailRules: false,
        }
    }),
    init() {
        $listen('open-register', options => this.openCallback(options))

        this.getInterests()
    },
    destruct() {
    },
    openCallback(options = {}) {

        _.forEach(options, (value, key) => {
            Vue.set(this.states.form, key, value)
        })

        this.states.visible = true
        this.states.is_open = true
    },
    getInterests() {
        axios.get("/interest/all")
            .then(resp => {
                this.states.interests = resp.data.interests;
            })
    },
    closeRequest() {
        if (this.states.is_closing === false)
            this.states.is_closing = true
    },
    close(){
        this.states.is_open=false
        this.states.visible=false
        this.states.is_closing=false

        _.forEach({
            is_closing: false,
            is_open: false,
            visible: false,
            loading: false,
            ages: [18, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 80],
            interests: [],
            steps: [
                RegisterAuth,
                RegisterBase1,
                RegisterBase2,
                RegisterAboutMe,
                RegisterAboutPartner,
                RegisterInterests,
                RegisterFinal,
            ],
            current_step: 1,
            isSocialRegister: false,
            form: {
                username: '',
                password: '',
                i_am: "man",
                looking_for: "woman",
                start_age: 18,
                end_age: 70,
                countries: [],
                place: null,
                avatar: null,
                dob: null,
                about_me: '',
                about_partner: '',
                interests: [],
                rules: false,
                dataRules: false,
                emailRules: false,
            }
        }, (value, key) => {
            Vue.set(this.states, key, value)
        })
    },
    continue() {
        this.states.is_closing = false
    },
    step() {
        return this.states.steps[this.states.current_step - 1]
    },
    prev() {
        if (this.states.current_step === 2 && this.states.isSocialRegister === true) return

        this.states.current_step !== 1 && (
            this.states.current_step--
        )
    },
    hasNoErrors(bag, keys) {
        let result = true
        keys.forEach(key => {
            _.get(bag, key, false) !== false && (result = false)
        })

        return result
    },

    composeForm() {
        let form = _.cloneDeep(this.states.form);
        form.dob = moment(form.dob).format('MM/DD/yyyy')
        form.countries = form.countries.map(item => item.id)
        form.place = _.get(form.place, 'id', null)

        return form
    },

    submit() {
        this.states.loading = true

        let baseForm = this.composeForm();
        console.log(baseForm.avatar)
        let form = new FormData();

        _.forEach(baseForm, (value, key) => {
            if (value === true) {
                form.append(key, 1)
            } else if (value === false) {
                form.append(key, 0)
            } else if (_.isArray(value)) {
                value.forEach(val => {
                    form.append(`${key}[]`, val)
                })
            } else {
                form.append(key, value)
            }
        });

        if (this.states.isSocialRegister) {
            form.append('is_social_register', 1);
        }

        axios.post('/register', form, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(resp => {
                if (_.has(resp, 'data.msg')) {
                    Vue.$toast.success(resp.data.msg);
                    location.href = `/${window.locale}/dashboard`;
                }
            }).catch(err => {
            if (err.response.status === 422) {
                _.forEach(err.response.data.errors, item => Vue.$toast.error(item[0]))
            }
        }).finally(() => {
            this.states.loading = false
        })
    }
}
